module.exports = __webpack_public_path__ + "static/tietoja-palvelusta-f3bdc64e2e16ff187d8148b4eaea7805.png";